import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faPencil } from "@fortawesome/free-solid-svg-icons";

const RenderRow = ({ index, style, bloqueados = [], setItemToEdit }) => {

    return (
        <div style={style} className='container-p-list productRow'>
            <li>
                <div className='container-p-list-item'>
                    <div className="container-p-list-item-horizontal">
                        <div className='list-item-icon-p'><FontAwesomeIcon icon={faBan} /></div>
                        <div className="label-title-products">Nro. Socio: <div className="label-products">{bloqueados[index].nroSocio}</div></div>
                        <div className="label-title-products">Nombre: <div className="label-products">{bloqueados[index].nombre}</div></div>
                        <div className="label-title-products">Motivo: <div className="label-products">{bloqueados[index].textoAdicional}</div></div>
                    </div>
                    <div className="utilitesDiv" onClick={() => setItemToEdit(bloqueados[index])}>
                        <FontAwesomeIcon className="utilityIcon" icon={faPencil} />
                    </div>
                </div>
            </li>
        </div>
    );
};

export default RenderRow;
